// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
    margin: 0;
    gap: 10px;
    padding: 0;
    display: flex;
    list-style: none;
    place-items: center;
    flex-direction: column;
}
  
    .pharma {
      width:80%;
      text-align: center;
      background-color: #962E2A;
      border-radius: 3rem;
      color:white;
      padding: 1rem 1rem 1rem 1rem;
      font-weight: bold;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .ITCommon {
      width:80%;
      text-align: center;
      background-color: #28a745;
      text-decoration: none;
      border-radius: 3rem;
      color:white;
      font-weight: bold;
      padding: 1rem 1rem 1rem 1rem;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .ITCommon>a,.Useful-info>a{
      color:white;
    }

    .Useful-info {
      width:80%;
      text-align: center;
      background-color: #219ebc  ;
      text-decoration: none;
      border-radius: 3rem;
      color:white;
      font-weight: bold;
      padding: 1rem 1rem 1rem 1rem;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .other {
        width:80%;
        text-align: center;
        background-color: #ffd147;
        text-decoration: none;
        border-radius: 3rem;
        font-weight: bold;
        padding: 1rem 1rem 1rem 1rem;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .cardStyle{
      height: 97%;
      margin: 10px;
      border-radius: 10px;
      border:none;
      box-shadow:0 4px 4px 0 rgba(150,46,42,0.5), 0 6px 20px 0 rgba(150,46,42,0.5)

    }
    .content-outerdiv{
      display: inline-block;
      width: 70%;
      height: 100%;
      border-radius: 20px 0px 0px 20px;
    }
    .card-outerdiv{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .card-innerdiv{
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    `, "",{"version":3,"sources":["webpack://./src/components/modules/trainings/content/Content.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;IAEI;MACE,SAAS;MACT,kBAAkB;MAClB,yBAAyB;MACzB,mBAAmB;MACnB,WAAW;MACX,4BAA4B;MAC5B,iBAAiB;MACjB,4EAA4E;IAC9E;IACA;MACE,SAAS;MACT,kBAAkB;MAClB,yBAAyB;MACzB,qBAAqB;MACrB,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,4BAA4B;MAC5B,4EAA4E;IAC9E;IACA;MACE,WAAW;IACb;;IAEA;MACE,SAAS;MACT,kBAAkB;MAClB,2BAA2B;MAC3B,qBAAqB;MACrB,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,4BAA4B;MAC5B,4EAA4E;IAC9E;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB,yBAAyB;QACzB,qBAAqB;QACrB,mBAAmB;QACnB,iBAAiB;QACjB,4BAA4B;QAC5B,4EAA4E;IAChF;IACA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,WAAW;MACX;;IAEF;IACA;MACE,qBAAqB;MACrB,UAAU;MACV,YAAY;MACZ,gCAAgC;IAClC;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;IACd;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;IACb","sourcesContent":["ul {\n    margin: 0;\n    gap: 10px;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    place-items: center;\n    flex-direction: column;\n}\n  \n    .pharma {\n      width:80%;\n      text-align: center;\n      background-color: #962E2A;\n      border-radius: 3rem;\n      color:white;\n      padding: 1rem 1rem 1rem 1rem;\n      font-weight: bold;\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n    .ITCommon {\n      width:80%;\n      text-align: center;\n      background-color: #28a745;\n      text-decoration: none;\n      border-radius: 3rem;\n      color:white;\n      font-weight: bold;\n      padding: 1rem 1rem 1rem 1rem;\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n    .ITCommon>a,.Useful-info>a{\n      color:white;\n    }\n\n    .Useful-info {\n      width:80%;\n      text-align: center;\n      background-color: #219ebc  ;\n      text-decoration: none;\n      border-radius: 3rem;\n      color:white;\n      font-weight: bold;\n      padding: 1rem 1rem 1rem 1rem;\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n    \n    .other {\n        width:80%;\n        text-align: center;\n        background-color: #ffd147;\n        text-decoration: none;\n        border-radius: 3rem;\n        font-weight: bold;\n        padding: 1rem 1rem 1rem 1rem;\n        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n    .cardStyle{\n      height: 97%;\n      margin: 10px;\n      border-radius: 10px;\n      border:none;\n      box-shadow:0 4px 4px 0 rgba(150,46,42,0.5), 0 6px 20px 0 rgba(150,46,42,0.5)\n\n    }\n    .content-outerdiv{\n      display: inline-block;\n      width: 70%;\n      height: 100%;\n      border-radius: 20px 0px 0px 20px;\n    }\n    .card-outerdiv{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n    }\n    .card-innerdiv{\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n    }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
